export default {
    info: {
        method: 'GET',
        url: '/user/:uid/recent/{time}',
        name: '获取用户信息',
    },
    getAllShopList: {
        method: 'POST',
        url: '/manage-system/shop/page',
        name: '分页查询门店',
    },
    selectList: {
        method: 'GET',
        url: '/manage-system/shop/all',
        name: '场地下拉',
    },
    cityList: {
        method: 'GET',
        url: '/manage-system/shop/allCity',
        name: '场地城市下拉列表',
    },
    shopInfo: {
        method: 'POST',
        url: '/manage-system/shop',
        name: '新增场地',
    },
    shopInfoUpdate: {
        method: 'PUT',
        url: '/manage-system/shop',
        name: '编辑场地',
    },
    shopDetail: {
        method: 'GET',
        url: '/manage-system/shop/{id}',
        name: '场地详情',
    },
    storeConfig: {
        method: 'GET',
        url: '/admin/storeConfig/{shopId}',
        name: '获得场地下所有库存配置－场次类型',
    },
    ticketList: {
        method: 'POST',
        url: '/manage-system/ticket/queryTicketTemplateInfoPage',
        name: '分页查询票券模板列表'
    },
    ticketSelectList: {
        method: 'POST',
        url: '/manage-system/ticket/queryTicketTemplateInfoPage',
        name: '票券下拉列表',
    },
    getTicketList: {
        method: 'POST',
        url: '/manage-system/ticket/queryTicketTemplateSnapshotInfoPage',
        name: '所有票',
    },
    ticketState: {
        method: 'PUT',
        url: '/manage-system/ticket/shelves/{ticketTemplateId}/{state}',
        name: '票券上下架',
    },
    createTicket: {
        method: 'POST',
        url: '/manage-system/ticket/addTicket',
        name: '添加票券',
    },
    updateTicket: {
        method: 'POST',
        url: '/manage-system/ticket/updateTicket',
        name: '编辑票券',
    },
    ticketDetail: {
        method: 'GET',
        url: '/manage-system/ticket/getTicketInfoById/{ticketTemplateId}',
        name: '根据id获取票券详情',
    },
    addCoupon: {
        method: 'POST',
        url: '/manage-system/coupon/admin/add',
        name: '新增优惠劵',
    },
    couponList: {
        method: 'POST',
        url: '/manage-system/coupon/admin/list',
        name: '优惠劵列表',
    },
    couponDetail: {
        method: 'GET',
        url: '/admin/coupon/{id}',
        name: "优惠券详情"
    },
    addStore: {
        method: 'POST',
        url: '/manage-system/reserve/stock/addReserveStock',
        name: "新增库存项目"
    },
    getStore: {
        method: 'POST',
        url: '/manage-system/reserve/stock/getReserveStockByShopAndType',
        name: "获取门店下类别的库存列表"
    },
    batchAddPeriod: {
        method: 'POST',
        url: '/manage-system/reserve/period/batchAddPeriod',
        name: "生成库存"
    },
    storeTypes: {
        method: 'GET',
        url: '/manage-system/reserve/period/getReservePeriodTypeByShop/{shopId}',
        name: "获取门店的预约场次类型"
    },
    addStoreType: {
        method: 'POST',
        url: '/manage-system/reserve/period/addReservePeriodType',
        name: "添加预约场次类型"
    },
    getPeriodList: {
        method:"POST",
        url:"/admin/storeConfig/periodList",
        name:"库存配置场次列表"
    },
    getDateStore:{
        method:"POST",
        url:"/manage-system/reserve/period/getPeriodByDate",
        name:"获取预约库存日期段的场次信息"
    },
    setPeriodTime:{
        method:"POST",
        url:"/manage-system/reserve/period/batchUpdatePeriod",
        name:"修改场次时间"
    },
    setStoreNum:{
        method:"POST",
        url:"/manage-system/reserve/period/upadtePeriodStock",
        name:"修改场次库存"
    },
    delStoreConfig: {
        method: "GET",
        url: "/manage-system/reserve/stock/delReserveStock/{id}",
        name: "删除预约库存配置"
    },
    editStoreConfig: {
        method: "POST",
        url: "/manage-system/reserve/stock/modifyReserveStock",
        name: "更新预约库存信息"
    },
    updateTicketList:{
        method:"GET",
        url:"/admin/ticket/updateTicketList",
        name:"票升级列表"
    },
    batchAddSellCounter: {
        method: "POST",
        url: "/manage-system/ticket/sell/batchAddSellCounter",
        name: "批量添加票券售卖收银台"
    }, 
    queryTicketSellCounterPage: {
        method: "POST",
        url: "/manage-system/ticket/sell/queryTicketSellCounterPage",
        name: "分页查询票券售卖收银台列表",
    },
    delPeriod : {
        method:"POST",
        url:"/manage-system/reserve/period/delReservePeriod",
        name:"删除库存场次"
    },
    editPeriod : {
        method:"PUT",
        url:"/admin/storeConfig/period",
        name:"修改场次库存"
    },
    menuList: {
        method:"GET",
        url:"/admin/ticket/menuList/{shopId}",
        name:"获取所有的菜品"
    },

    channelList: {
        method: "POST",
        url: "/manage-system/channel/page",
        name: "用户渠道管理分页"
    },
    channelFreeze:{
        method:"PUT",
        url:"/manage-system/channel/freeze/{id}",
        name:"渠道冻结"
    },
    channelUnfreeze:{
        method:"PUT",
        url:"/manage-system/channel/unfreeze/{id}",
        name:"渠道解冻"
    },
    toggleFreeze:{
        method:"PUT",
        url:"/manage-system/channel/toggleFreeze",
        name:"批量冻结/解冻"
    },
    channelAdd: {
        method:"POST",
        url:"/manage-system/channel",
        name:"用户渠道管理新增"
    },
    queryInfo : {
        method:"POST",
        url:"/manage-system/channel/log/query",
        name:"访问详情"
    },
    relationCoupons : {
        method:"GET",
        url:"/admin/coupon/relationCoupons",
        name:"关联票券列表"
    },
    rewardCoupons : {
        method:"GET",
        url:"/admin/coupon/rewardCoupons",
        name:"关联奖励优惠券列表"
    },
    rewardTickets : {
        method:"GET",
        url:"/admin/coupon/rewardTickets",
        name:"关联奖励票券列表"
    },
    suitTickets : {
        method:"GET",
        url:"/admin/coupon/suitTickets",
        name:"关联适用票券列表"
    },
    distributionUser : {
        method:"POST",
        url:"/admin/coupon/distributionUser",
        name:"分发用户查看(折扣券、满减券)"
    },
    distribution2User : {
        method:"POST",
        url:"/admin/coupon/distribution2User",
        name:"分发用户查看(分享券)"
    },
    couponState: {
        method:"PUT",
        url:"/admin/coupon/state",
        name:"分发用户禁用"
    },
    sendCoupon: {
        method:"POST",
        url:"/admin/coupon/sendCoupon",
        name:"发送分享券优惠券"
    },
    sendCouponsList: {
        method:"GET",
        url:"/admin/coupon/sendCoupons/{type}",
        name:"发送优惠券列表"
    },
    couponDelete: {
        method:"DELETE",
        url:"/admin/coupon/{id}",
        name:"优惠劵删除"
    },
    triggerTickets: {
        method:"GET",
        url:"/admin/coupon/triggerTickets",
        name:"票券切换领取"
    },
    triggerCoupons: {
        method:"GET",
        url:"/admin/coupon/triggerCoupons",
        name:"优惠券切换领取"
    },
    storedConfigDetail: {
        method:"GET",
        url:"/manage-system/balance/card/config",
        name:"获取储值配置"
    },
    storedConfig: {
        method:"PUT",
        url:"/manage-system/balance/card/config",
        name:"设置储值配置"
    },
    getStoredValueCard: {
        method:"GET",
        url:"/manage-system/balance/card/card",
        name:"储值卡列表"
    },
    addStoredValueCard: {
        method:"POST",
        url:"/manage-system/balance/card/card",
        name:"新增储值卡"
    },
    editStoredValueCard: {
        method:"PUT",
        url:"/manage-system/balance/card/card",
        name:"编辑储值卡"
    },
    delStoredValueCard: {
        method:"DELETE",
        url:"/manage-system/balance/card/card/{id}",
        name:"删除储值卡"
    },
    disableStoredValueCard: {
        method:"PUT",
        url:"/manage-system/balance/card/card/disable/{id}",
        name:"下架储值卡"
    },
    enableStoredValueCard: {
        method:"PUT",
        url:"/manage-system/balance/card/card/enable/{id}",
        name:"上架储值卡"
    },
    menuList2: {
        method:"GET",
        url:"/admin/ticket/menuList2/{shopId}",
        name:"获取所有的菜品（阿派朗）"
    },
    removeTicket: {
        method:"PUT",
        url:"/manage-system/ticket/delTicketTemplate/{ticketTemplateId}",
        name:"票券删除"
    },
    autoChangeState: {
        method:"PUT",
        url:"/admin/ticket/autoChangeState",
        name:"自动上/下架"
    },
    exportPeriod: {
        method:"POST",
        url:"/admin/storeConfig/period/export",
        name:"导出预约名单"
    },
    periodList: {
        method:"POST",
        url:"/admin/storeConfig/new/periodList",
        name:"批量关闭场次库存配置场次列表"
    },
    closePeriodList: {
        method:"POST",
        url:"/manage-system/reserve/period/closeReservePeriod",
        name:"批量关闭场次库存"
    },
    batchExport: {
        method:"POST",
        url:"/manage-system/reserve/exportByPeriodId",
        name:"批量导出预约名单"
    },
    getPeriodById: {
        method:"GET",
        url:"/manage-system/reserve/period/getPeriodById/{periodId}",
        name:"获取场次库存信息"
    },
    getClosePeriodList: {
        method: "POST",
        url: "/manage-system/reserve/period/closePeriodList",
        name: "关闭场次列表"
    },
    getRemarkCategoryByOperate: {
        method:"GET",
        url:"/manage-system/remark/category/{operateCode}",
        name:"获取操作的备注类型"
    },
    menuList2new: {
        method:"GET",
        url:"/admin/ticket/menuList2new/{shopId}",
        name:"获取所有的菜品(阿派朗点餐) 有规格 new"
    },
    addTotalStock: {
        method: "POST",
        url: "/manage-system/ticket/stock/addTotalStock",
        name: "添加票券总库存"
    },
    setTicketStock: {
        method: "POST",
        url: "/manage-system/ticket/setTicketStock",
        name: "设置票券库存值"
    },
    setTicketSellTime: {
        method: "POST",
        url: "/manage-system/ticket/setTicketSellTime",
        name: "设置票券售卖时间"
    },
    getTicketSellTimeInfo: {
        method: "GET",
        url: "/manage-system/ticket/getTicketSellTimeInfo/{ticketTemplateId}",
        name: "获取票券售卖时间信息"
    },
    getReservePeriodListInfo: {
        method: "POST",
        url: "/manage-system/reserve/period/getReservePeriodListInfo",
        name: "获取场次列表"
    },
    getTotalTicketList: {
        method: "POST",
        url: "/manage-system/ticket/getTicketListByCondition",
        name: '获取补开卡票券列表'
    },
    updatePeriod: {
        method: "POST",
        url: "/manage-system/reserve/period/updatePeriod",
        name: "更改库存"
    },
    exportReserveRecord: {
        method: "GET",
        url: "/manage-system/reserve/period/exportReserveRecord",
        name: "预约导出"
    },

    getDateList: {
        method: "GET",
        url: "/manage-system/sys/calendar/getDateList",
        name: "获取日期列表"
    },
    getDate: {
        method: "GET",
        url: "/manage-system/sys/calendar/getDate",
        name: "查看单天日期类型"
    },
    copyShopCalendar: {
        method: "POST",
        url: "/manage-system/sys/calendar/copyShopCalendar",
        name: "复制门店日历"
    },
    batchSetDate: {
        method: "POST",
        url: "/manage-system/sys/calendar/batchSetDate",
        name: "批量设置日期"
    },
    batchSetBusinessHours: {
        method: "POST",
        url: "/manage-system/sys/businessHours/batchSetBusinessHours",
        name: "批量设置营业时间"
    },
    delBusinessHours: {
        method: "GET",
        url: "/manage-system/sys/businessHours/delBusinessHours/{id}",
        name: "根据id删除营业时间"
    },
    queryBusinessHours: {
        method: "POST",
        url: "/manage-system/sys/businessHours/queryBusinessHours",
        name: "查询营业时间"
    },
    channelExport: {
        method: "POST",
        url: "/manage-system/channel/log/export",
        name: "导出访问记录"
    },
}